import { FC } from 'react';
import s from './MinimumAmountLabel.module.scss';

const MinimumAmountLabel: FC<{ minimumAmount: number; amountError?: boolean }> = ({ minimumAmount, amountError }) => {
  if (!(minimumAmount > 0 || amountError)) return <></>;
  return (
    <div className={s.minimumAmountContainer}>
      {minimumAmount > 0 && (
        <div>
          <span className={s.minimumAmountLabel}>Minimum amount: </span>
          <span className={s.minimumAmountValue}>${minimumAmount}</span>
        </div>
      )}
      <div>{amountError && <p className={s.minimumAmountError}>You must pay at least the minimum amount</p>}</div>
    </div>
  );
};

export default MinimumAmountLabel;
